import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import axios from "axios";
import { Box, Button, IconButton, LinearProgress, Modal } from '@mui/material';
import { ArrowForward, ArrowUpwardOutlined, CheckCircle, Clear, GpsFixed } from '@mui/icons-material';
import { Erroralert, Successalert } from './popups';
import { Saveclientplanurl } from '../Utils/urls';
import { getsessionuser, setsessionuser } from '../Utils/sessions';


export default function Upgradepopup({ ondismiss, hostelid, gotofund, onsuccessplan }) {

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const user = getsessionuser()

    const [loading, setloading] = useState(false);

    const [packagechoosen, setpackagechoosen] = useState('');
    const [showinsufficientbalance, setshowinsufficientbalance] = useState(false);



    const submitpackage = () => {
        if (parseInt(user.wallet) < 20) {
            setshowinsufficientbalance(true)
        } else if (packagechoosen === "Premium" && parseInt(user.wallet) < 300) {
            setshowinsufficientbalance(true)
        } else if (packagechoosen === "Gold" && parseInt(user.wallet) < 600) {
            setshowinsufficientbalance(true)
        } else {
            setloading(true)
            seterror(null)
            axios.post(Saveclientplanurl, {
                id: user.id,
                plan: packagechoosen,
                hostelid: hostelid
            }).then(response => {
                setloading(false)
                if (!response.data.error) {
                    user.currentplan = response.data.currentplan
                    user.hostelssubscribed = response.data.hostelssubscribed
                    user.wallet = response.data.wallet
                    setsessionuser(user)
                    setsuccess("Upgrade successfull")
                    setTimeout(() => {
                        onsuccessplan()
                        setsuccess('')
                    }, 3000);
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry there was an error try again later")

            });
        }
    }

    return (
        <Modal
            open={true}
            onClose={() => ondismiss()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container component="main" maxWidth="sm" style={{ backgroundColor: "white", marginTop: 5, borderRadius: 20 }}>
                <CssBaseline />
                <div>
                    <p align="right">
                        <IconButton onClick={() => ondismiss()}>
                            <Clear />
                        </IconButton>
                    </p>
                    {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
                    {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
                    <div className='agenttitle'>Choose upgrade package</div>
                    <div className={packagechoosen === "Basic" ? 'packagedivactive' : 'packagediv'} onClick={() => setpackagechoosen("Basic")}>
                        {packagechoosen === "Basic" && <div className='checkcircle'><CheckCircle /></div>}
                        <div className='packagetitle'><b>Basic:</b> 20ksh </div>
                        <div className='packagedescription'>Access the contact and location of one hostel</div>
                    </div>
                    <div className={packagechoosen === "Premium" ? 'packagedivactive' : 'packagediv'} onClick={() => setpackagechoosen("Premium")}>
                        {packagechoosen === "Premium" && <div className='checkcircle'><CheckCircle /></div>}
                        <div className='packagetitle'><b>Premium:</b> 300ksh </div>
                        <div className='packagedescription'>Access to information about all listed hostels</div>
                    </div>
                    <div className={packagechoosen === "Gold" ? 'packagedivactive' : 'packagediv'} onClick={() => setpackagechoosen("Gold")}>
                        {packagechoosen === "Gold" && <div className='checkcircle'><CheckCircle /></div>}
                        <div className='packagetitle'><b>Gold:</b> 599ksh </div>
                        <div className='packagedescription'>Access to information about all listed hostels, plus
                            the services of an agent to search for a room on your behalf
                        </div>
                    </div>
                    {showinsufficientbalance &&
                        <div style={{ fontSize: 13 }}>
                            Insufficient wallet balance.<div onClick={() => gotofund()} style={{ color: "blue" ,cursor:"pointer"}}>Click to here to fund your account</div>
                        </div>}
                    {loading && <LinearProgress color='primary' />}
                    {packagechoosen &&
                        <p align="middle">
                            <Button onClick={() => submitpackage()} variant='contained' endIcon={<ArrowUpwardOutlined />}>
                                Submit
                            </Button>
                        </p>}

                </div>
                <br /><br />
            </Container>
        </Modal>

    );
}
